import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazySiteAdmin = lazyWithRetry(() => import("./SiteAdmin"));

const SiteAdmin = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazySiteAdmin {...props} />;

export default SiteAdmin;
